<template>
    <div class="nopads">
        <div class="row" v-if="!this.hideRoadInfo">
            <div class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.road_number') }}</span>
                <input
                    v-model="roadInfo.road_num"
                    type="number"
                    min="0"
                    :class="['form-control form-control-sm', validateRoadNumber(roadInfo.road_num) === true ? 'is-valid' : validateRoadNumber(roadInfo.road_num) === false ? 'is-invalid' : '']"
                />
            </div>

            <div class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.road_section_number') }}</span>
                <input
                    v-model="roadInfo.road_sec"
                    type="number"
                    min="0"
                    :class="['form-control form-control-sm', validateRoadSection(roadInfo.road_sec) === true ? 'is-valid' : validateRoadSection(roadInfo.road_sec) === false ? 'is-invalid' : '']"
                />
            </div>

            <div class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.distance') }}</span>
                <input
                    v-model="roadInfo.distance"
                    type="number"
                    min="0"
                    :class="['form-control form-control-sm', validateRoadDistance(roadInfo.distance) === true ? 'is-valid' : validateRoadDistance(roadInfo.distance) === false ? 'is-invalid' : '']"
                />
            </div>
        </div>
        <div class="row">
            <!-- Tracks -->
            <div v-if="!hideTracksSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_conversion.tracks') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.tracks"
                    :disabled="isDisabledByRule('tracks', locationSpecification.tracks, tracksRequired)"
                    :class="{'is-invalid': tracksRequired && locationSpecification.tracks == null,'is-valid': tracksRequired && locationSpecification.tracks != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_track') }}</option>
                    <option v-for="option in tracksSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Side -->
            <div v-if="!hideSideSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('road_sign.side') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.side"
                    :disabled="isDisabledByRule('side', locationSpecification.side, sideRequired)"
                    :class="{'is-invalid': sideRequired && locationSpecification.side == null,'is-valid': sideRequired && locationSpecification.side != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_side') }}</option>
                    <option v-for="option in sideSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Center Areas -->
            <div v-if="!hideCenterAreaSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.center_areas') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.center_area"
                    :disabled="isDisabledByRule('center_area', locationSpecification.center_area, centerAreaRequired)"
                    :class="{'is-invalid': centerAreaRequired && locationSpecification.center_area == null, 'is-valid': centerAreaRequired && locationSpecification.center_area != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_center_area') }}</option>
                    <option v-for="option in centerAreaSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Ramps -->
            <div v-if="!hideRampSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.ramps') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.ramps"
                    :disabled="isDisabledByRule('ramps', locationSpecification.ramps, rampRequired)"
                    :class="{'is-invalid': rampRequired && locationSpecification.ramps == null,'is-valid': rampRequired && locationSpecification.ramps != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_ramp') }}</option>
                    <option v-for="option in rampSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Shoulders -->
            <div v-if="!hideShoulderSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.shoulders') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.shoulders"
                    :disabled="isDisabledByRule('shoulders', locationSpecification.shoulders, shoulderRequired)"
                    :class="{'is-invalid': shoulderRequired && locationSpecification.shoulders == null,'is-valid': shoulderRequired && locationSpecification.shoulders != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_shoulder') }}</option>
                    <option v-for="option in shouldersSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Platforms -->
            <div v-if="!hidePlatformSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.platforms') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.platforms"
                    :disabled="isDisabledByRule('platforms', locationSpecification.platforms, platformRequired)"
                    :class="{'is-invalid': platformRequired && locationSpecification.platforms == null,'is-valid': platformRequired && locationSpecification.platforms != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_platform') }}</option>
                    <option v-for="option in platformSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Edge Areas -->
            <div v-if="!hideEdgeAreaSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.edge_areas') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.edge_areas"
                    :disabled="isDisabledByRule('edge_areas', locationSpecification.edge_areas, edgeAreaRequired)"
                    :class="{'is-invalid': edgeAreaRequired && locationSpecification.edge_areas == null,'is-valid': edgeAreaRequired && locationSpecification.edge_areas != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_edge_area') }}</option>
                    <option v-for="option in edgeAreasSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Ditch Bottoms -->
            <div v-if="!hideDitchBottomSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.ditch_bottoms') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.ditch_bottoms"
                    :disabled="isDisabledByRule('ditch_bottoms', locationSpecification.ditch_bottoms, ditchBottomRequired)"
                    :class="{'is-invalid': ditchBottomRequired && locationSpecification.ditch_bottoms == null, 'is-valid': ditchBottomRequired && locationSpecification.ditch_bottoms != null}">
                    <option :value="null">{{ $t('velho_equipment.select_equipment_ditch_bottom') }}</option>
                    <option v-for="option in ditchBottomSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <!-- Dividers -->
            <div v-if="!hideDividerSelector" class="col-sm-4 nopads pl-1 pr-1">
                <span class="span-title">{{ $t('velho_equipment.dividers') }}</span>
                <select
                    class="form-select form-select-sm"
                    v-model="locationSpecification.dividers"
                    :disabled="isDisabledByRule('dividers', locationSpecification.dividers, dividerRequired)"
                    :class="{'is-invalid': dividerRequired && locationSpecification.dividers == null,'is-valid': dividerRequired && locationSpecification.dividers != null}"
                >
                    <option :value="null">{{ $t('velho_equipment.select_equipment_divider') }}</option>
                    <option v-for="option in dividerSelector" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { velhoHelper, side, tracks, ramps, shoulders, platforms, edgeAreas, ditchBottoms, dividers, locationDeviationCenterArea } from "@/components/mixins/VelhoMixin";
import { velhoValidationMixin } from "@/components/mixins/VelhoValidationMixin";

export default {
    name: 'velho-equipment-location-details-editor',
    mixins: [velhoHelper, velhoValidationMixin],
    components: {},
    props: {
        roadInfo: {
            type: Object,
            default: null
        },
        locationSpecification: {
            type: Object,
            default: null
        },
        hideSideSelector: {
            type: Boolean,
            default: false
        },
        hideRoadInfo: {
            type: Boolean,
            default: false
        },
        hideTracksSelector: {
            type: Boolean,
            default: false
        },
        hideRampSelector: {
            type: Boolean,
            default: false
        },
        hideShoulderSelector: {
            type: Boolean,
            default: false
        },
        hidePlatformSelector: {
            type: Boolean,
            default: false
        },
        hideEdgeAreaSelector: {
            type: Boolean,
            default: false
        },
        hideDividerSelector: {
            type: Boolean,
            default: false
        },
        hideDitchBottomSelector: {
            type: Boolean,
            default: false
        },
        hideCenterAreaSelector: {
            type: Boolean,
            default: false
        },
        tracksRequired: {
            type: Boolean,
            default: false
        },
        sideRequired: {
            type: Boolean,
            default: false
        },
        rampRequired: {
            type: Boolean,
            default: false
        },
        shoulderRequired: {
            type: Boolean,
            default: false
        },
        platformRequired: {
            type: Boolean,
            default: false
        },
        edgeAreaRequired: {
            type: Boolean,
            default: false
        },
        dividerRequired: {
            type: Boolean,
            default: false
        },
        ditchBottomRequired: {
            type: Boolean,
            default: false
        },
        centerAreaRequired: {
            type: Boolean,
            default: false
        },
        disableRule: Function
    },
    computed: {
        sideSelector() {
            return Object.values(side).map(value => {
                return {
                    text: this.getVelhoSideString(value),
                    value: value
                }
            });

        },
        tracksSelector() {
            return Object.values(tracks).map(value => {
                return {
                    text: this.getVelhoTrackString(value),
                    value: value
                }
            });
        },
        rampSelector() {
            return Object.values(ramps).map(value => {
                return {
                    text: this.getVelhoRampString(value),
                    value: value
                }
            });
        },
        shouldersSelector() {
            return Object.values(shoulders).map(value => {
                return {
                    text: this.getVelhoShoulderString(value),
                    value: value
                }
            });
        },
        edgeAreasSelector() {
            return Object.values(edgeAreas).map(value => {
                return {
                    text: this.getVelhoEdgeAreaString(value),
                    value: value
                }
            });
        },
        platformSelector() {
            return Object.values(platforms).map(value => {
                return {
                    text: this.getVelhoPlatformString(value),
                    value: value
                }
            });
        },
        dividerSelector() {
            return Object.values(dividers).map(value => {
                return {
                    text: this.getVelhoDividerString(value),
                    value: value
                }
            });
        },
        ditchBottomSelector() {
            return Object.values(ditchBottoms).map(value => {
                return {
                    text: this.getVelhoDitchBottomString(value),
                    value: value
                }
            });
        },
        centerAreaSelector() {
            return Object.values(locationDeviationCenterArea).map(value => {
                return {
                    text: this.getVelhoCenterAreasString(value),
                    value: value
                }
            });
        }
    },
    data() {
        return {}
    },
    methods: {
        isDisabledByRule(selector, value , required) {
            if(required){
                return false;
            }
            return this.disableRule ? this.disableRule(selector, value) : false;
        }
    }
}
</script>
<style lang="css" scoped>
.required {
  border-color: red;
}
.valid{
    border-color: green;
}
</style>
